import {object, SchemaOf, string} from 'yup';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {isValidEmail} from 'shared/web';

import {EmailData} from '../types/EmailData';

export const $EmailData: SchemaOf<EmailData> = object({
  type: string().defined().nullable(),
  email: string()
    .defined()
    .nullable()
    .test(
      'customerEmail',
      () => i18n.t('general.validations.invalidEmail'),
      (value) => isNil(value) || value.trim() === '' || isValidEmail(value.trim())
    ),
});
